<template>
  <v-tabs v-model="tabs">
    <v-tab :key="1">{{ labels.profile }}</v-tab>
    <v-tab-item :key="1">
      <v-card>
        <v-toolbar dense color="grey lighten-5" flat>
          <v-icon>mdi-format-align-justify</v-icon>
          <v-toolbar-title class="toolbar-title-2">{{ labels.general }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-container fluid grid-list-sm>
            <v-layout row wrap>
              <v-flex xs2 v-if="newIntermediary">
                <v-autocomplete
                  :label="labels.interGroup"
                  v-model="interForm.interGroupCode"
                  :items="interGroupList"
                  item-text="label"
                  item-value="value"
                  data-vv-name="interGroup"
                  :data-vv-as="labels.interGroup"
                  :error-messages="errors.collect('interGroup')"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs2 v-else> </v-flex>
              <v-flex xs2 v-if="newIntermediary">
                <v-checkbox :label="labels.interNoAe" v-model="interForm.interNoAe" @change="doInterNoAe"></v-checkbox>
              </v-flex>
              <v-flex xs2 v-else> </v-flex>
              <v-flex xs4 v-if="newIntermediary">
                <v-flex v-if="!interForm.interNoAe">
                  <v-text-field
                    :label="labels.inter"
                    v-model="interForm.inter"
                    :error-messages="errors.collect('inter')"
                    v-validate="'required|param|max:8'"
                    data-vv-name="inter"
                    :data-vv-as="labels.inter"
                  ></v-text-field>
                </v-flex>
              </v-flex>
              <v-flex xs4 v-else> </v-flex>
              <v-flex xs4>
                <!-- <v-autocomplete :label="labels.interType" v-model="interForm.interType" :items="interTypeList" item-text="label" item-value="value" data-vv-name="interType" :data-vv-as="labels.interType" :error-messages="errors.collect('interType')"></v-autocomplete> -->
                <v-text-field
                  v-model="interForm.interType"
                  :label="labels.interType"
                  :error-messages="errors.collect('interType')"
                  :data-vv-as="labels.interType"
                  data-vv-name="interType"
                  append-icon="mdi-magnify"
                  @click:append="showInterTypeHelpList = true"
                  @click="showInterTypeHelpList = true"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-select
                  :items="interTitleList"
                  v-model="interForm.titleName"
                  :label="labels.titleName"
                  item-text="label"
                  item-value="value"
                  data-vv-name="titleName"
                  :data-vv-as="labels.titleName"
                  :error-messages="errors.collect('titleName')"
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  :label="labels.intermediaryName"
                  v-model="interForm.intermediaryName"
                  :error-messages="errors.collect('intermediaryName')"
                  v-validate="'required|entry|max:60|sanction:' + sanctionName1Error"
                  @change="valSanction(interForm.intermediaryName, '', 'sanctionName1Error')"
                  data-vv-name="intermediaryName"
                  :data-vv-as="labels.intermediaryName"
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  :label="labels.abbrevName"
                  v-model="interForm.abbrevName"
                  :error-messages="errors.collect('abbrevName')"
                  v-validate="'required|entry|max:25|sanction:' + sanctionName2Error"
                  @change="valSanction(interForm.abbrevName, '', 'sanctionName2Error')"
                  data-vv-name="abbrevName"
                  :data-vv-as="labels.abbrevName"
                ></v-text-field>
              </v-flex>
              <v-flex xs4 v-if="!newIntermediary">
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ interForm.createdBy }}</div>
              </v-flex>
              <v-flex xs4 v-if="!newIntermediary">
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDate(interForm.createdDate) }}</div>
              </v-flex>
              <v-flex xs4 v-if="!newIntermediary"> </v-flex>
              <v-flex xs4 v-if="!newIntermediary">
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ interForm.modifiedBy }}</div>
              </v-flex>
              <v-flex xs4 v-if="!newIntermediary">
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDate(interForm.modifiedDate) }}</div>
              </v-flex>
              <v-flex xs4 v-if="!newIntermediary"> </v-flex>
              <v-flex xs12 class="mt-2">
                <v-expansion-panels v-model="toogleArray" multiple>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <div>
                        <span class="headerTitle">Contact & Details</span>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card-text>
                        <v-container fluid grid-list-sm>
                          <v-layout row wrap>
                            <v-flex xs4>
                              <v-text-field
                                :label="labels.contact"
                                v-model="interForm.contact"
                                :error-messages="errors.collect('contact')"
                                v-validate="'entry|max:30'"
                                data-vv-name="contact"
                                :data-vv-as="labels.contact"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs4>
                              <v-text-field
                                :label="labels.telNo1"
                                v-model="interForm.telNo1"
                                type="tel"
                                :error-messages="errors.collect('telNo1')"
                                v-validate="'entry|max:20'"
                                data-vv-name="telNo1"
                                :data-vv-as="labels.telNo1"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs4>
                              <v-text-field
                                :label="labels.telNo2"
                                v-model="interForm.telNo2"
                                type="tel"
                                :error-messages="errors.collect('telNo2')"
                                v-validate="'entry|max:20'"
                                data-vv-name="telNo2"
                                :data-vv-as="labels.telNo2"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs4>
                              <v-text-field
                                :label="labels.telNo3"
                                v-model="interForm.telNo3"
                                type="tel"
                                :error-messages="errors.collect('telNo3')"
                                v-validate="'entry|max:20'"
                                data-vv-name="telNo3"
                                :data-vv-as="labels.telNo3"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs4>
                              <v-text-field
                                :label="labels.telNo4"
                                v-model="interForm.telNo4"
                                type="tel"
                                :error-messages="errors.collect('telNo4')"
                                v-validate="'entry|max:20'"
                                data-vv-name="telNo4"
                                :data-vv-as="labels.telNo4"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs4>
                              <v-text-field
                                :label="labels.telNo5"
                                v-model="interForm.telNo5"
                                type="tel"
                                :error-messages="errors.collect('telNo5')"
                                v-validate="'entry|max:20'"
                                data-vv-name="telNo5"
                                :data-vv-as="labels.telNo5"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs4>
                              <v-text-field
                                :label="labels.add1"
                                v-model="interForm.add1"
                                :error-messages="errors.collect('add1')"
                                v-validate="'max:60'"
                                data-vv-name="add1"
                                :data-vv-as="labels.add1"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs4>
                              <v-text-field
                                :label="labels.add2"
                                v-model="interForm.add2"
                                :error-messages="errors.collect('add2')"
                                v-validate="'max:60'"
                                data-vv-name="add2"
                                :data-vv-as="labels.add2"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs4>
                              <v-text-field
                                :label="labels.add3"
                                v-model="interForm.add3"
                                :error-messages="errors.collect('add3')"
                                v-validate="'max:60'"
                                data-vv-name="add3"
                                :data-vv-as="labels.add3"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs4>
                              <v-text-field
                                :label="labels.add4"
                                v-model="interForm.add4"
                                :error-messages="errors.collect('add4')"
                                v-validate="'max:60'"
                                data-vv-name="add4"
                                :data-vv-as="labels.add4"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs4>
                              <v-text-field
                                :label="labels.postalCode"
                                v-model="interForm.postalCode"
                                v-int-mask="{ intScale: 8 }"
                                type="tel"
                                :error-messages="errors.collect('postalCode')"
                                v-validate="'numeric|max:8'"
                                data-vv-name="postalCode"
                                :data-vv-as="labels.postalCode"
                                :loading="InterPostalCodeLoading"
                                @change="doInterAddress"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs2> </v-flex>
                            <v-flex xs2> </v-flex>
                            <v-flex xs4>
                              <v-text-field
                                v-model="interForm.email"
                                :label="labels.email"
                                :error-messages="errors.collect('email')"
                                data-vv-name="email"
                                :data-vv-as="labels.email"
                                v-validate="'email|max:50'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs4>
                              <v-text-field
                                :label="labels.web"
                                v-model="interForm.web"
                                :error-messages="errors.collect('web')"
                                v-validate="'entry|max:40'"
                                data-vv-name="web"
                                :data-vv-as="labels.web"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs4> </v-flex>
                            <v-flex xs4 v-if="newIntermediary">
                              <cal-picker
                                :label="labels.dateOpened"
                                v-model="interForm.dateOpened"
                                :error-messages="errors.collect('dateOpened')"
                                data-vv-name="dateOpened"
                                :data-vv-as="labels.dateOpened"
                                v-validate="startDateValidation"
                              ></cal-picker>
                            </v-flex>
                            <v-flex xs4 v-else>
                              <cal-picker
                                :label="labels.dateOpened"
                                v-model="interForm.dateOpened"
                                :error-messages="errors.collect('dateOpened')"
                                data-vv-name="dateOpened"
                                :data-vv-as="labels.dateOpened"
                              ></cal-picker>
                            </v-flex>
                            <v-flex xs4>
                              <cal-picker
                                :label="labels.dateClosed"
                                v-model="interForm.dateClosed"
                                :error-messages="errors.collect('dateClosed')"
                                data-vv-name="dateClosed"
                                :data-vv-as="labels.dateClosed"
                                v-validate="endDateValidation"
                              ></cal-picker>
                            </v-flex>
                            <v-flex xs4>
                              <v-select
                                :items="interCommTypeList"
                                v-model="interForm.commType"
                                :label="labels.commType"
                                item-text="label"
                                item-value="value"
                                data-vv-name="commType"
                                :data-vv-as="labels.commType"
                                :error-messages="errors.collect('commType')"
                              ></v-select>
                            </v-flex>
                            <v-flex xs4>
                              <v-autocomplete
                                :label="labels.branch"
                                v-model="interForm.branch"
                                :items="interHomeBranchList"
                                item-text="label"
                                item-value="value"
                                data-vv-name="branch"
                                :data-vv-as="labels.branch"
                                :error-messages="errors.collect('branch')"
                                v-validate="'required'"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex xs4>
                              <v-autocomplete
                                :label="labels.cty"
                                v-model="interForm.cty"
                                :items="interCountryList"
                                item-text="label"
                                item-value="value"
                                data-vv-name="cty"
                                :data-vv-as="labels.cty"
                                :error-messages="errors.collect('cty')"
                                v-validate="'required'"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex xs4>
                              <v-select
                                :items="interRegAgtList"
                                v-model="interForm.regAgt"
                                :label="labels.regAgt"
                                item-text="label"
                                item-value="value"
                                data-vv-name="regAgt"
                                :data-vv-as="labels.regAgt"
                                :error-messages="errors.collect('regAgt')"
                              ></v-select>
                            </v-flex>
                            <v-flex xs4>
                              <v-text-field
                                v-uppercase="interForm.gstRegNo"
                                v-model="interForm.gstRegNo"
                                :label="labels.gstRegNo"
                                :error-messages="errors.collect('gstRegNo')"
                                data-vv-name="gstRegNo"
                                :data-vv-as="labels.gstRegNo"
                                v-validate="'entry|max:20'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs4>
                              <cal-picker
                                :label="labels.gstRegDate"
                                v-model="interForm.gstRegDate"
                                :error-messages="errors.collect('gstRegDate')"
                                data-vv-name="gstRegDate"
                                :data-vv-as="labels.gstRegDate"
                              ></cal-picker>
                            </v-flex>
                            <v-flex xs4>
                              <v-autocomplete
                                :items="gstKeyRegAgtList"
                                v-model="interForm.gstKeyRegAgt"
                                :label="labels.gstKeyRegAgt"
                                item-text="label"
                                item-value="value"
                                data-vv-name="gstKeyRegAgt"
                                :data-vv-as="labels.gstKeyRegAgt"
                                :error-messages="errors.collect('gstKeyRegAgt')"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex xs4>
                              <v-text-field
                                :label="labels.crPer"
                                v-model="interForm.crPer"
                                :error-messages="errors.collect('crPer')"
                                v-validate="'numeric|max:3'"
                                data-vv-name="crPer"
                                :data-vv-as="labels.crPer"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs4>
                              <v-text-field
                                :label="labels.crLim"
                                v-model="interForm.crLim"
                                :error-messages="errors.collect('crLim')"
                                data-vv-name="crLim"
                                :data-vv-as="labels.crLim"
                                v-validate="'required|mask_decimal:2|mask_max_value:9999999.99'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs4>
                              <v-autocomplete
                                :label="labels.crLimCurr"
                                v-model="interForm.crLimCurr"
                                :items="interCurrList"
                                item-text="label"
                                item-value="value"
                                data-vv-name="crLimCurr"
                                :data-vv-as="labels.crLimCurr"
                                :error-messages="errors.collect('crLimCurr')"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex xs4>
                              <v-checkbox :label="labels.perDebtTran" v-model="interForm.perDebtTran"></v-checkbox>
                            </v-flex>
                            <v-flex xs4>
                              <v-checkbox :label="labels.blackList" v-model="interForm.blackList"></v-checkbox>
                            </v-flex>
                            <v-flex xs4>
                              <v-checkbox :label="labels.inactive" v-model="interForm.inactive"></v-checkbox>
                            </v-flex>
                            <v-flex xs4>
                              <v-checkbox :label="labels.suspended" v-model="interForm.suspended"></v-checkbox>
                            </v-flex>
                            <v-flex xs4>
                              <v-select
                                :items="interInsdDiscList"
                                v-model="interForm.insdDisc"
                                :label="labels.insdDisc"
                                item-text="label"
                                item-value="value"
                                data-vv-name="insdDisc"
                                :data-vv-as="labels.insdDisc"
                                :error-messages="errors.collect('insdDisc')"
                              ></v-select>
                            </v-flex>
                            <v-flex xs4>
                              <v-autocomplete
                                :label="labels.execIC"
                                v-model="interForm.execIC"
                                :items="interExecICList"
                                item-text="label"
                                item-value="value"
                                data-vv-name="execIC"
                                :data-vv-as="labels.execIC"
                                :error-messages="errors.collect('execIC')"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex xs4>
                              <v-checkbox
                                :label="labels.schemeMand"
                                v-model="interForm.schemeMand"
                                :disabled="!checkAccess([permissionKeys.perm_050210])"
                              ></v-checkbox>
                            </v-flex>
                            <v-flex xs4>
                              <v-select
                                :items="interStmtTypeList"
                                v-model="interForm.stmtType"
                                :label="labels.stmtType"
                                item-text="label"
                                item-value="value"
                                data-vv-name="stmtType"
                                :data-vv-as="labels.stmtType"
                                :error-messages="errors.collect('stmtType')"
                              ></v-select>
                            </v-flex>
                            <v-flex xs4>
                              <v-text-field
                                v-model="interForm.grpRefStmt"
                                :label="labels.grpRefStmt"
                                :error-messages="errors.collect('grpRefStmt')"
                                data-vv-name="grpRefStmt"
                                :data-vv-as="labels.grpRefStmt"
                                v-validate="isValidGrpRefStmt"
                                @blur="doGetDesc(interForm.grpRefStmt, 'grpRefStmt')"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="doInterHelpList('grpRefStmt')" v-text="'mdi-magnify'"></v-icon>
                                </v-slide-x-reverse-transition>
                              </v-text-field>
                            </v-flex>
                            <v-flex xs4>
                              <v-text-field
                                v-model="interForm.grpRefAge"
                                :label="labels.grpRefAge"
                                :error-messages="errors.collect('grpRefAge')"
                                data-vv-name="grpRefAge"
                                :data-vv-as="labels.grpRefAge"
                                v-validate="isValidGrpRefAge"
                                @blur="doGetDesc(interForm.grpRefAge, 'grpRefAge')"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="doInterHelpList('grpRefAge')" v-text="'mdi-magnify'"></v-icon>
                                </v-slide-x-reverse-transition>
                              </v-text-field>
                            </v-flex>
                            <v-flex xs4>
                              <v-text-field
                                :label="labels.defNoPrtDrCr"
                                v-model="interForm.defNoPrtDrCr"
                                :error-messages="errors.collect('defNoPrtDrCr')"
                                v-validate="'numeric|max:10'"
                                data-vv-name="defNoPrtDrCr"
                                :data-vv-as="labels.defNoPrtDrCr"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs4>
                              <v-checkbox :label="labels.isDM" v-model="interForm.isDM"></v-checkbox>
                            </v-flex>
                            <v-flex xs4>
                              <v-autocomplete
                                :label="labels.prtBuyerCreatedTaxInv"
                                v-model="interForm.prtBuyerCreatedTaxInv"
                                :items="interGstStatusList"
                                item-text="label"
                                item-value="label"
                                data-vv-name="interForm.prtBuyerCreatedTaxInv"
                                :data-vv-as="labels.prtBuyerCreatedTaxInv"
                                :error-messages="errors.collect('interForm.prtBuyerCreatedTaxInv')"
                              ></v-autocomplete>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-flex>

              <!--LYT Added: 2020-08-27  Sanction Partial Matched Names List -->
              <v-dialog v-model="showSanctionDialog" width="1280px">
                <sanction-partial-match-list
                  :sanctionItems="sanctionPartialMatchItems"
                  @close="showSanctionDialog = false"
                ></sanction-partial-match-list>
              </v-dialog>
            </v-layout>
          </v-container>
          <!-- InterType Help List -->
          <v-dialog v-model="showInterTypeHelpList" width="900px">
            <intermediary-type-help-list
              @close="showInterTypeHelpList = false"
              @assign-interType-data="assignInterType"
            ></intermediary-type-help-list>
          </v-dialog>
          <!-- Intermediary Help List -->
          <v-dialog v-model="showInterHelpList" width="900px" persistent>
            <intermediary-help-list
              :interGrps="'10,11,20,25'"
              @close="showInterHelpList = false"
              @assign-intermediary-data="assignIntermediary"
            ></intermediary-help-list>
          </v-dialog>
        </v-card-text>
        <v-card-actions>
          <v-flex lg6 md12 xs12>
            <v-btn class="white--text error mr-2" @click.prevent="doBack">
              Cancel
              <v-icon right>mdi-cancel</v-icon>
            </v-btn>
            <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSave">
              {{ newIntermediary ? 'Add Intermediary' : 'Update Intermediary' }}
              <v-icon right>{{ newIntermediary ? 'mdi-plus' : 'mdi-content-save' }}</v-icon>
            </v-btn>
          </v-flex>
        </v-card-actions>
        <confirm v-model="promptAddNew" @cancel="doCancelAddNew" @ok="doAddNew"> Do you want to add more? </confirm>
      </v-card>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import { interTitle, interCommType, interRegAgt, interStmtType, interInsdDisc } from '@/const/underwriting'
import { mapGetters, mapActions } from 'vuex'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import IntermediaryTypeHelpList from '@/components/core/common/dialog/IntermediaryTypeHelpList'
import IntermediaryHelpList from '@/components/core/common/dialog/IntermediaryHelpList'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import clone from 'clone'
import SanctionPartialMatchList from '@/components/core/common/dialog/SanctionPartialMatchList'
import { permissionKeys } from '@/mixins/global/permissionKey'

export default {
  data() {
    return {
      permissionKeys: permissionKeys,
      tabs: 0,
      toogleArray: [0],
      labels: {
        profile: 'Profile',
        general: 'General',
        interNoAe: 'Intermediary Reference',
        inter: 'Intermediary Reference*',
        interGroup: 'Intermediary Group*',
        titleName: 'Title',
        intermediaryName: 'Intermediary Name*',
        interType: 'Intermediary Type',
        abbrevName: 'Abbreviated Name*',
        contact: 'Contact Person',
        telNo1: 'Telephone',
        telNo2: 'Telephone 2',
        telNo3: 'Telephone 3',
        telNo4: 'Telephone 4',
        telNo5: 'Telephone 5',
        add1: 'Address',
        add2: 'Address 2',
        add3: 'Address 3',
        add4: 'Address 4',
        postalCode: 'Postal Code',
        addrState: 'State',
        addrCtry: 'Country',
        email: 'Email',
        web: 'Web page',
        dateOpened: 'Date Opened*',
        dateClosed: 'Date Closed',
        commType: 'Commission Entitlement',
        branch: 'Home Branch*',
        cty: 'Country*',
        regAgt: 'Registered Agent',
        gstRegNo: 'GST Registration No',
        gstRegDate: 'GST Registration Date',
        gstKeyRegAgt: 'GST Key Registered Agent',
        crPer: 'Credit Period(days)',
        crLim: 'Credit Limit',
        crLimCurr: 'Credit Limit Currency',
        perDebtTran: 'Permit Debtor Transaction',
        blackList: 'Is blackListed?',
        inactive: 'Is InActive?',
        suspended: 'Is Suspended?',
        insdDisc: 'Permit Insured Discount',
        execIC: 'Executive in charge',
        schemeMand: 'Scheme Mandatory',
        stmtType: 'Statement Type',
        grpRefStmt: 'Group Intermediary No. for Statement',
        grpRefAge: 'Group Intermediary No. for Ageing',
        defNoPrtDrCr: 'Default No. Dr / Cr Note',
        isDM: 'Is DM Intermediary?',
        createdBy: 'Created by',
        createdDate: 'Created Date',
        modifiedBy: 'Modified by',
        modifiedDate: 'Modified Date',
        prtBuyerCreatedTaxInv: 'Print Buyer-Created Tax Invoice for Comm GST Status'
      },
      interForm: {
        interNoAe: true,
        inter: undefined,
        interGroupCode: '10',
        interGroupName: undefined,
        titleName: undefined,
        intermediaryName: undefined,
        interType: undefined,
        abbrevName: undefined,
        contact: undefined,
        telNo1: undefined,
        telNo2: undefined,
        telNo3: undefined,
        telNo4: undefined,
        telNo5: undefined,
        add1: undefined,
        add2: undefined,
        add3: undefined,
        add4: undefined,
        postalCode: undefined,
        addrState: undefined,
        addrCtry: undefined,
        email: undefined,
        web: undefined,
        dateOpened: new Date(),
        dateClosed: undefined,
        commType: 'O',
        branch: undefined,
        cty: undefined,
        regAgt: undefined,
        gstRegNo: undefined,
        gstRegDate: undefined,
        gstKeyRegAgt: undefined,
        crPer: 0,
        crLim: 0,
        crLimCurr: undefined,
        perDebtTran: false,
        blackList: false,
        inactive: false,
        suspended: false,
        insdDisc: undefined,
        execIC: undefined,
        schemeMand: false,
        stmtType: undefined,
        grpRefStmt: undefined,
        grpRefAge: undefined,
        defNoPrtDrCr: 0,
        isDM: false,
        createdBy: undefined,
        createdDate: undefined,
        modifiedBy: undefined,
        modifiedDate: undefined,
        prtBuyerCreatedTaxInv: undefined
      },
      interGroupList: [],
      interCountryList: [],
      interTypeList: [],
      interHomeBranchList: [],
      gstKeyRegAgtList: [],
      interCurrList: [],
      interExecICList: [],
      interList: [],
      interByInterGrpList: [],
      menu: [],
      newIntermediary: false,
      submitting: false,
      InterPostalCodeLoading: false,
      expandPanel: false,
      promptAddNew: false,
      showInterHelpList: false,
      group: undefined,
      validGrpRefStmt: false,
      validGrpRefAge: false,
      showInterTypeHelpList: false,
      selectedInterType: '',
      interGstStatusList: []
    }
  },
  computed: {
    ...mapGetters(['checkAccess']),
    startDateValidation() {
      return 'required'
    },
    endDateValidation() {
      if (this.interForm.dateClosed !== undefined && this.interForm.dateClosed !== '') {
        return 'entry|start_enddate:' + this.interForm.dateOpened
      } else {
        return ''
      }
    },
    intermediaryForm() {
      return this.$store.state.adminInter.intermediary
    },
    interTitleList() {
      let result = []
      Object.keys(interTitle).forEach(function(key) {
        const status = interTitle[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    interCommTypeList() {
      let result = []
      Object.keys(interCommType).forEach(function(key) {
        const status = interCommType[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    interRegAgtList() {
      let result = []
      Object.keys(interRegAgt).forEach(function(key) {
        const status = interRegAgt[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    interStmtTypeList() {
      let result = []
      Object.keys(interStmtType).forEach(function(key) {
        const status = interStmtType[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    interInsdDiscList() {
      let result = []
      Object.keys(interInsdDisc).forEach(function(key) {
        const status = interInsdDisc[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    isValidGrpRefStmt() {
      if (this.validGrpRefStmt && this.interForm.grpRefStmt !== '') {
        return 'entry|grpRefStmt:' + this.validGrpRefStmt
      } else {
        return ''
      }
    },
    isValidGrpRefAge() {
      if (this.validGrpRefAge && this.interForm.grpRefAge !== '') {
        return 'entry|grpRefAge:' + this.validGrpRefAge
      } else {
        return ''
      }
    }
  },
  methods: {
    ...mapActions(['interMenuInit', 'commonsInit']),
    doInit() {
      try {
        // Default value from vuex store 1st
        this.interForm.interNoAe = this.intermediaryForm.interNoAe
        this.interForm.inter = this.intermediaryForm.inter
        this.interForm.interGroupCode = this.intermediaryForm.interGroupCode
        this.interForm.interGroupName = this.intermediaryForm.interGroupName
        this.interForm.interType = this.intermediaryForm.interType
        this.selectedInterType = this.intermediaryForm.interType
        this.interForm.titleName = this.intermediaryForm.titleName
        this.interForm.intermediaryName = this.intermediaryForm.intermediaryName
        this.interForm.abbrevName = this.intermediaryForm.abbrevName
        this.interForm.contact = this.intermediaryForm.contact
        this.interForm.telNo1 = this.intermediaryForm.telNo1
        this.interForm.telNo2 = this.intermediaryForm.telNo2
        this.interForm.telNo3 = this.intermediaryForm.telNo3
        this.interForm.telNo4 = this.intermediaryForm.telNo4
        this.interForm.telNo5 = this.intermediaryForm.telNo5
        this.interForm.add1 = this.intermediaryForm.add1
        this.interForm.add2 = this.intermediaryForm.add2
        this.interForm.add3 = this.intermediaryForm.add3
        this.interForm.add4 = this.intermediaryForm.add4
        this.interForm.postalCode = this.intermediaryForm.postalCode
        this.interForm.addrState = this.intermediaryForm.addrState
        this.interForm.addrCtry = this.intermediaryForm.addrCtry
        this.interForm.email = this.intermediaryForm.email
        this.interForm.web = this.intermediaryForm.web
        if (this.intermediaryForm.dateOpened) {
          this.interForm.dateOpened = this.intermediaryForm.dateOpened
        }
        if (this.intermediaryForm.dateClosed) {
          this.interForm.dateClosed = this.intermediaryForm.dateClosed
        }
        this.interForm.commType = this.intermediaryForm.commType
        this.interForm.branch = this.intermediaryForm.branch
        this.interForm.cty = this.intermediaryForm.cty
        this.interForm.regAgt = this.intermediaryForm.regAgt
        this.interForm.gstRegNo = this.intermediaryForm.gstRegNo
        if (this.intermediaryForm.gstRegDate) {
          this.interForm.gstRegDate = this.intermediaryForm.gstRegDate
        }
        this.interForm.gstKeyRegAgt = this.intermediaryForm.gstKeyRegAgt
        this.interForm.crPer = this.intermediaryForm.crPer
        this.interForm.crLim = this.intermediaryForm.crLim
        this.interForm.crLimCurr = this.intermediaryForm.crLimCurr
        if (this.intermediaryForm.perDebtTran) {
          this.interForm.perDebtTran = this.intermediaryForm.perDebtTran
        } else {
          this.interForm.perDebtTran = false
        }
        if (this.intermediaryForm.blackList) {
          this.interForm.blackList = this.intermediaryForm.blackList
        } else {
          this.interForm.blackList = false
        }
        if (this.intermediaryForm.inactive) {
          this.interForm.inactive = this.intermediaryForm.inactive
        } else {
          this.interForm.inactive = false
        }
        if (this.intermediaryForm.suspended) {
          this.interForm.suspended = this.intermediaryForm.suspended
        } else {
          this.interForm.suspended = false
        }
        this.interForm.insdDisc = this.intermediaryForm.insdDisc
        this.interForm.execIC = this.intermediaryForm.execIC
        if (this.intermediaryForm.schemeMand) {
          this.interForm.schemeMand = this.intermediaryForm.schemeMand
        } else {
          this.interForm.schemeMand = false
        }
        this.interForm.stmtType = this.intermediaryForm.stmtType
        this.interForm.grpRefStmt = this.intermediaryForm.grpRefStmt
        this.interForm.grpRefAge = this.intermediaryForm.grpRefAge
        this.interForm.defNoPrtDrCr = this.intermediaryForm.defNoPrtDrCr
        if (this.intermediaryForm.isDM) {
          this.interForm.isDM = this.intermediaryForm.isDM
        } else {
          this.interForm.isDM = false
        }
        this.interForm.prtBuyerCreatedTaxInv = this.intermediaryForm.prtBuyerCreatedTaxInv
        this.interForm.createdBy = this.intermediaryForm.strCreatedBy
        this.interForm.modifiedBy = this.intermediaryForm.strModifiedBy
        if (this.intermediaryForm.createdDate) {
          this.interForm.createdDate = this.intermediaryForm.createdDate
        }
        if (this.intermediaryForm.modifiedDate) {
          this.interForm.modifiedDate = this.intermediaryForm.modifiedDate
        }
      } catch (err) {}
    },
    async getInterGroupList() {
      const apiURI = this.$store.state.adminInter.menu.interGroup
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result
        if (data) {
          this.interGroupList = data.data.interGroupList
        }
      } catch (err) {
        throw err
      }
    },
    async getInterCtyList() {
      const apiURI = this.$store.state.adminInter.menu.countryList
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.interCountryList = data
        }
      } catch (err) {
        throw err
      }
    },
    async getInterTypeList() {
      const apiURI = this.$store.state.adminInter.menu.interTypeList
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          if (this.newIntermediary) {
            this.interForm.interType = result.data.data.interType
            this.selectedInterType = result.data.data.interType
          }
          this.interTypeList = result.data.data.interTypeList
        }
      } catch (err) {
        throw err
      }
    },
    async doInterAddress() {
      const apiUrl = this.$store.state.adminInter.menu.address
      if (apiUrl) {
        try {
          this.InterPostalCodeLoading = true
          const expand = {
            postCode: this.interForm.postalCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.interForm.add1 = data.add1
            this.interForm.add2 = data.add2
            this.interForm.add4 = data.add4
          }
          this.InterPostalCodeLoading = false
        } catch (err) {
          this.InterPostalCodeLoading = false
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async getInterHomeBranchList() {
      const apiURI = this.$store.state.adminInter.menu.homeBranchList
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.interHomeBranchList = data
        }
      } catch (err) {
        throw err
      }
    },
    async getInterCurrList() {
      const apiURI = this.$store.state.adminInter.menu.currencyList
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.interCurrList = data
        }
      } catch (err) {
        throw err
      }
    },
    async getGstKeyRegAgtList() {
      const apiURI = this.$store.state.adminInter.menu.gstKeyRegAgtList
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.gstKeyRegAgtList = data
        }
      } catch (err) {
        throw err
      }
    },
    async getInterExecICList() {
      const apiURI = this.$store.state.adminInter.menu.execICList
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.interExecICList = data
        }
      } catch (err) {
        throw err
      }
    },
    async getInterByInterGrpList() {
      const apiURI = this.$store.state.adminInter.menu.interByInterGrpList
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.interByInterGrpList = data
        }
      } catch (err) {
        throw err
      }
    },
    async getInterList() {
      const apiURI = this.$store.state.adminInter.menu.interList
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.interList = data
        }
      } catch (err) {
        throw err
      }
    },
    async getDefStmtType() {
      const apiURI = this.$store.state.adminInter.menu.getDefStmtType
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result
        if (data) {
          this.interForm.stmtType = data.data.defStmtType
        }
      } catch (err) {
        const data = err.response
        if (data) {
          this.message(data)
          this.fieldMessage(data)
        }
      }
    },
    async getInterGstStatusList() {
      const apiURI = this.$store.state.adminInter.menu.gstStatusList
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.interGstStatusList = data
        }
      } catch (err) {
        const { data } = err.response
        if (data) {
          this.message(data)
          this.fieldMessage(data)
        }
      }
    },
    doBack() {
      this.$router.push({ name: 'intermediaries' })
    },
    doSave() {
      this.toogleArray = [0]
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newIntermediary) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doUpdate() {
      const apiURI = this.$store.state.adminInter.intermediary.menu.updateInter
      if (!apiURI) {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        return
      }
      this.submitting = true
      try {
        this.interForm.interType = this.selectedInterType
        const messageFilters = clone(this.interForm)
        messageFilters.grpRefStmt = this.extractCode(this.interForm.grpRefStmt)
        messageFilters.grpRefAge = this.extractCode(this.interForm.grpRefAge)
        messageFilters.prtBuyerCreatedTaxInv = this.extractCode(this.interForm.prtBuyerCreatedTaxInv)
        const result = await this.$http.put(apiURI, messageFilters)
        if (result.data) {
          this.notify(result.data)
          this.$store.dispatch('interMenuInit', this.interForm.inter)
          this.$router.push({ name: 'reviewProfile' })
        }
      } catch (err) {
        const data = err.response
        if (data) {
          this.message(data)
          this.fieldMessage(data)
        }
      } finally {
        this.submitting = false
      }
    },
    extractCode(val) {
      return val ? val.split('-')[0].trim() : val
    },
    async doCreate() {
      if (this.interForm.branch === undefined || this.interForm.cty === undefined) {
        this.promptFieldCheck()
      } else {
        this.interForm.interType = this.selectedInterType
        const apiURI = this.$store.state.adminInter.menu.interCreate
        this.interForm.crLim = parseFloat(this.interForm.crLim)
        if (apiURI) {
          this.submitting = true
          try {
            let messageFilters = clone(this.interForm)
            const spltGrpRefStmt = this.interForm.grpRefStmt === undefined ? '' : this.interForm.grpRefStmt.split('-')
            const spltGrpRefAge = this.interForm.grpRefAge === undefined ? '' : this.interForm.grpRefAge.split('-')

            if (spltGrpRefStmt !== '' && spltGrpRefStmt !== null) {
              messageFilters.grpRefStmt = spltGrpRefStmt[0].trim()
            }

            if (spltGrpRefAge !== '' && spltGrpRefAge !== null) {
              messageFilters.grpRefAge = spltGrpRefAge[0].trim()
            }
            const result = await this.$http.post(apiURI, messageFilters)
            const { data } = result
            if (data) {
              // Show message via notify
              this.notify(data)
              if (this.interForm.inter == null) {
                this.interForm.inter = data.inter
              }

              this.promptAddNew = true

              // this.$store.dispatch('interMenuInit', this.interForm.inter)
              // this.newIntermediary = false
              // this.$router.push({ name: 'intermediaries' })
              // this.$router.push({ name: 'reviewDetails', params: { inter: this.interForm.inter } })
            }
            this.submitting = false
          } catch (err) {
            //
            if (err) {
              const { data } = err.response
              this.message(data)
              this.fieldMessage(data)
              this.notify(data)
            }
            this.submitting = false
          }
        } else {
          this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        }
      }
    },
    async doCancelAddNew() {
      this.$router.push({ name: 'intermediaries' })
    },
    async doAddNew() {
      this.newIntermediary = true
      this.doRefresh()
      this.$router.push({ name: 'reviewProfile', params: { inter: 'new', interGroupCode: 'new' } })
    },
    doRefresh() {
      this.toogleArray = [0]
      this.interForm.interNoAe = true
      this.interForm.inter = null
      this.interForm.interGroupCode = '10'
      this.interForm.interGroupName = null
      this.interForm.titleName = null
      this.interForm.intermediaryName = null
      this.interForm.interType = null
      this.selectedInterType = null
      this.interForm.abbrevName = null
      this.interForm.contact = null
      this.interForm.telNo1 = null
      this.interForm.telNo2 = null
      this.interForm.telNo3 = null
      this.interForm.telNo4 = null
      this.interForm.telNo5 = null
      this.interForm.add1 = null
      this.interForm.add2 = null
      this.interForm.add3 = null
      this.interForm.add4 = null
      this.interForm.postalCode = null
      this.interForm.addrState = null
      this.interForm.addrCtry = null
      this.interForm.email = null
      this.interForm.web = null
      this.interForm.dateOpened = new Date()
      this.interForm.dateClosed = null
      this.interForm.commType = 'O'
      this.interForm.branch = null
      this.interForm.cty = null
      this.interForm.regAgt = null
      this.interForm.gstRegNo = null
      this.interForm.gstRegDate = null
      this.interForm.gstKeyRegAgt = null
      this.interForm.crPer = 0
      this.interForm.crLim = 0
      this.interForm.crLimCurr = null
      this.interForm.perDebtTran = false
      this.interForm.blackList = false
      this.interForm.inactive = false
      this.interForm.suspended = false
      this.interForm.insdDisc = null
      this.interForm.execIC = null
      this.interForm.schemeMand = false
      this.interForm.stmtType = null
      this.interForm.grpRefStmt = undefined
      this.interForm.grpRefAge = undefined
      this.interForm.defNoPrtDrCr = 0
      this.interForm.isDM = false
      this.interForm.prtBuyerCreatedTaxInv = null
      this.interForm.createdBy = null
      this.interForm.createdDate = null
      this.interForm.modifiedBy = null
      this.interForm.modifiedDate = null
      this.getDefStmtType()
      this.getInterTypeList()
    },
    doInterNoAe() {
      if (this.interForm.interNoAe) {
        this.interForm.inter = null
        this.interForm.interNoAe = true
        this.errors.remove('inter')
      }
    },
    formatDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    },
    doInterHelpList(data) {
      this.group = data
      this.showInterHelpList = true
    },
    assignIntermediary(data) {
      if (this.group === 'grpRefStmt') {
        this.interForm.grpRefStmt = data.inter + ' - ' + data.name
        this.validGrpRefStmt = false
      } else if (this.group === 'grpRefAge') {
        this.interForm.grpRefAge = data.inter + ' - ' + data.name
        this.validGrpRefAge = false
      }
      this.showInterHelpList = false
    },
    assignInterType(data) {
      this.showInterTypeHelpList = false
      this.interForm.interType = data.value + ' - ' + data.label
      this.selectedInterType = data.value
    },
    doGetDesc(event, field) {
      this.group = field
      const data = event.split('-')
      if (data !== '') {
        const fliterData = {
          group: 'group',
          inter: data[0]
        }
        this.getDataDesc('intermediary', fliterData)
      }
    },
    doAssignDesc(data) {
      if (this.group === 'grpRefStmt') {
        if (data.id !== undefined) {
          this.interForm.grpRefStmt = data.id + ' - ' + data.name
          this.validGrpRefStmt = false
        } else {
          this.validGrpRefStmt = true
        }
      } else if (this.group === 'grpRefAge') {
        if (data.id !== undefined) {
          this.interForm.grpRefAge = data.id + ' - ' + data.name
          this.validGrpRefAge = false
        } else {
          this.validGrpRefAge = true
        }
      }
    }
  },
  created() {
    Promise.all([
      this.getInterGroupList(),
      this.getInterCtyList(),
      this.getInterTypeList(),
      this.getInterHomeBranchList(),
      this.getInterCurrList(),
      this.getInterExecICList(),
      this.getInterList(),
      this.getInterByInterGrpList(),
      this.getGstKeyRegAgtList(),
      this.getInterGstStatusList()
    ])
    if (this.inter === 'new') {
      this.getDefStmtType()
      this.newIntermediary = true
    } else {
      this.doInit()
    }

    this.$validator.extend('grpRefStmt', {
      getMessage(field, args) {
        return 'Invalid Data'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var stat = args[0]
        if (stat === true) {
          return true
        } else {
          return false
        }
      }
    })

    this.$validator.extend('grpRefAge', {
      getMessage(field, args) {
        return 'Invalid Data'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var stat = args[0]
        if (stat === true) {
          return true
        } else {
          return false
        }
      }
    })
  },
  props: ['inter', 'interGroupCode', 'interNoAe'],
  mixins: [MessageMixin, commonAjaxMixin],
  components: {
    IntermediaryTypeHelpList,
    IntermediaryHelpList,
    SanctionPartialMatchList
  }
}
</script>

<style lang="scss"></style>
